var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { h } from "preact";
import MaterialComponent from "../MaterialComponent";
import Icon from "../Icon/";

/**
 *  @prop dense = false
 *  @prop raised = false
 *  @prop compact = false
 *  @prop disabled = false
 *  @prop unelevated = false
 *  @prop stroked = false
 */
class Button extends MaterialComponent {
  constructor() {
    super();
    this.componentName = "button";
    this._mdcProps = ["dense", "raised", "compact", "unelevated", "stroked"];
  }
  componentDidMount() {
    super.attachRipple();
  }
  materialDom(props) {
    const ButtonElement = props.href ? "a" : "button";

    return h(
      ButtonElement,
      _extends({
        ref: control => {
          this.control = control;
        }
      }, props),
      this.props.children
    );
  }
}

class ButtonIcon extends Icon {
  constructor() {
    super();
    this.componentName = "button__icon";
  }
}

Button.Icon = ButtonIcon;
export default Button;


// WEBPACK FOOTER //
// ../~/preact-material-components/Button/index.js